import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import kansasCity__asset from "@/assets/restore/locations/kansas-city.jpg.asset.json";
import stLouis__asset from "@/assets/restore/locations/st-louis.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Kansas City",
    address: "2300 Main Street, Suite 900",
    img: kansasCity__asset.url,
    mapUrl: map("2300 Main Street Kansas City MO"),
    to: "/locations/missouri/kansas-city/",
  },
  {
    name: "St. Louis",
    address: "2 Cityplace Dr, 2nd Floor",
    img: stLouis__asset.url,
    mapUrl: map("2 Cityplace Dr St. Louis MO"),
    to: "/locations/missouri/st-louis/",
  },
];

export const Route = createFileRoute("/locations/missouri/")({
  head: () => ({
    meta: [
      { title: "Missouri Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Missouri. Book a free hair loss consultation in Kansas City or St. Louis and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Missouri Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across Missouri and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/missouri/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/missouri/" }],
  }),
  component: () => <StateLocationsHub stateName="Missouri" cities={cities} />,
});